import { Box, styled, Button } from '@mui/material';

export const StyledCompactCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '24px',
  padding: '24px',
  backgroundColor: '#fff',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: '12px',
  marginBottom: '24px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '16px',
    padding: '20px',
  },
}));

export const StyledTopCardContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const StyledContentContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: '16px',
}));

export const StyledReserveButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(0),
  minWidth: '135px',
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
    marginTop: theme.spacing(0),
  },
  [theme.breakpoints.down(920)]: {
    minWidth: '100%',
    marginTop: theme.spacing(3),
  },
}));
